import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSignedURL } from '../services/Service';
import YourImage from '../assets/UserAvtarBackground.png';

const useUserProfileImage = () => {
  const { user } = useSelector((state) => state.login);
  const [userProfileImage, setImage] = useState(YourImage);

  const getProfileImage = async () => {
    const photoURL = user.profilePic || '';
    if (photoURL?.includes('safalsubscriptions-assets.s3.amazonaws.com')) {
      const newRes = await getSignedURL({ url: photoURL });
      setImage(newRes.data);
      return;
    }
    if (photoURL) {
      setImage(photoURL);
    }
  };

  useEffect(() => {
    getProfileImage();
  }, []);

  return userProfileImage;
};

export default useUserProfileImage;
